import Switch from "@material-ui/core/Switch"
import createSelectionComponent from "./createSelectionComponent"

export default createSelectionComponent(Switch, {
  defaultCheckedValue: true,
  isChecked: v => v,
})



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Field/Switch.js